module.exports = __webpack_public_path__ + "static/media/Recruitment.36b041ba.png";